<template lang="pug">
    div.packagesWrapper
        div.packagesOverlay
            div.packages
                div.packagesContent

                    // Title
                    title-component(:title="$t('payments.packagesPublic.title')" type="h1")

                    // Message
                    div.mb-4.packagesMessage(v-html="$t('payments.packagesPublic.message')")

                    // Packages
                    package-component(
                        v-for="(item, key) in $t('payments.packagesPublic.packagesNoTrial')"
                        :key="`package-${key}`"
                        :item="item"
                        :tabindex="key+1"
                    )

                    div.mb-2.mt-1 {{ $t('payments.packagesPublic.hint') }}

                    // Packages
                    package-component(
                        key="package-corporate"
                        :item="$t('payments.packagesPublic.packageCorporate')"
                    )

                    separator-component.my-3
                    div
                        span {{ `By continuing to use Chill Anywhere, you agree to our ` }}
                        router-link.corporateLink.mr-1(a to="/terms-and-conditions") Terms.
</template>

<script>
    import Layout from '../../Authorization/Layout';
    import Package from '~components/Package';
    import Separator from '~components/Separator';
    import Title from '~components/Title';

    export default {
        components: {
            Package,
            Layout,
            PackageComponent: Package,
            TitleComponent: Title,
            SeparatorComponent: Separator
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../assets/style/_variables.styl'

    .packagesWrapper
        position: absolute
        width: 100%
        min-height: 100%
        min-height: 100vh
        top: 0
        left: 0
        background-image: url('https://s3.us-east-2.amazonaws.com/chillanywhere.com/auth-images/3-min.jpg')
        background-size: cover
        background-position: center

    .packages
        display: flex
        align-items: center
        justify-content: center
        min-height: 100%
        min-height: 100vh
        padding: 20px

    .packagesMessage
        font-size: 13px

    .packagesContent
        width: 100%
        max-width: 520px
        padding: 16px
        border-radius: 10px
        background-color: $theme.primary

    .packagesOverlay
        height: 100%
        background: rgba(2, 35, 65, 0.4)

    .corporateTitle
        font-size: 20px

    .corporateDescription
        font-size: 13px

    .corporateLink
        color: $theme.action

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .packagesWrapper
            top: 16px
</style>
